import { supportReducer } from './reducers';

export default {
  support: supportReducer
};
